import React from 'react';
import { Link } from 'react-router-dom';
import usePageMeta from '../utils/usePageMeta';

const NotFound: React.FC = () => {
  usePageMeta({
    title: 'Page not found',
    description: 'That page does not exist.',
    path: '/404',
  });

  return (
    <main className="essay-home">
      <div className="essay-home__inner">
        <h1 className="essay-home__name">Page not found</h1>

        <div className="essay-home__copy">
          <p>
            That page doesn&rsquo;t exist. It may have moved, or the link may
            have been mistyped.
          </p>
        </div>

        <nav className="essay-home__links" aria-label="Go elsewhere">
          <Link to="/">Home</Link>
          <Link to="/work">Work</Link>
        </nav>
      </div>
    </main>
  );
};

export default NotFound;
